import Reactotron from 'reactotron-react-js';
// @ts-ignore
import apisaucePlugin from 'reactotron-apisauce';

import { useReactotron } from './configConstants';

if (useReactotron) {
  Reactotron.configure({
    // host: '10.0.3.2' // default is localhost (on android don't forget to `adb reverse tcp:9090 tcp:9090`)
    name: 'Shovel' // would you like to see your app's name?,
  })
    .use(apisaucePlugin({}))
    .connect();

  // Let's clear Reactotron on every time we load the app
  // @ts-ignore
  Reactotron.clear();
}

export const logger = useReactotron ? Reactotron.log! : console.log;
